import { getRequest } from "../../services/httpService";

//PRODUCTS VTEX RICKY
export const fetchApiDataVtex = () => async (dispatch) => {
  try {
    const source = `/vtex-items`;
    dispatch({ type: "FETCH_API_VTEX_LOADING", payload: [] });
    const response = await getRequest(source);
    dispatch({ type: "FETCH_API_VTEX_SUCCESS", payload: response.data });
    dispatch(getBatchVtexLast());
  } catch (error) {
    dispatch({ type: "FETCH_API_VTEX_FAILURE", payload: error.message });
  }
};

export const getBatchVtex = (page) => async (dispatch) => {
  try {
    dispatch({ type: "LOADING_START" });
    const source = `/vtexBatch/products?sortOrder=DESC&page=${page}`;

    const response = await getRequest(source);
    console.log(response.data);
    dispatch({ type: "BATCH_VTEX_SUCCESS", payload: response.data });
  } catch (error) {
    dispatch({ type: "BATCH_VTEX_FAILURE", payload: error.message });
  }
};

export const getBatchVtexLast = () => async (dispatch) => {
  try {
    const source = `/vtexBatch/products?last=true`;
    const response = await getRequest(source);
    dispatch({ type: "BATCH_VTEX_LAST_SUCCESS", payload: response.data });
  } catch (error) {
    dispatch({ type: "BATCH_VTEX_LAST_FAILURE", payload: error.message });
  }
};
//ORDERS VTEX RICKY
export const fetchApiDataVtexOrder = () => async (dispatch) => {
  try {
    const source = `/vtex-order`;
    dispatch({ type: "FETCH_API_VTEX_ORDER_LOADING", payload: [] });
    const response = await getRequest(source);
    dispatch({ type: "FETCH_API_VTEX_ORDER_SUCCESS", payload: response.data });
    dispatch(getBatchVtexLast());
  } catch (error) {
    dispatch({ type: "FETCH_API_VTEX_ORDER_FAILURE", payload: error.message });
  }
};

export const getBatchVtexOrder = (page) => async (dispatch) => {
  try {
    dispatch({ type: "LOADING_START" });
    const source = `/vtexBatch/orders?sortOrder=DESC&page=${page}`;

    const response = await getRequest(source);
    console.log(response.data);
    dispatch({ type: "BATCH_VTEX_ORDER_SUCCESS", payload: response.data });
  } catch (error) {
    dispatch({ type: "BATCH_VTEX_ORDER_FAILURE", payload: error.message });
  }
};

export const getBatchVtexOrderLast = () => async (dispatch) => {
  try {
    const source = `/vtexBatch/orders?last=true`;
    const response = await getRequest(source);
    dispatch({ type: "BATCH_VTEX_ORDER_LAST_SUCCESS", payload: response.data });
  } catch (error) {
    dispatch({ type: "BATCH_VTEX_ORDER_LAST_FAILURE", payload: error.message });
  }
};



//ORDERS SHOPIFY RICKY 
export const fetchApiDataShopifyRickyOrder = () => async (dispatch) => {
  try {
    const source = `/ricky-shopify-orders`;
    dispatch({ type: "FETCH_API_SHOPIFY_ORDER_LOADING", payload: [] });
    const response = await getRequest(source);
    dispatch({ type: "FETCH_API_SHOPIFY_ORDER_SUCCESS", payload: response.data });
    dispatch(getBatchShopifySarkanyusLast());
  } catch (error) {
    dispatch({ type: "FETCH_API_SHOPIFY_ORDER_FAILURE", payload: error.message });
  }
};

export const getBatchShopifyRickyOrder = (page) => async (dispatch) => {
  try {
    dispatch({ type: "LOADING_START" });
    const source = `/shopifySarkanyBatch/orders?sortOrder=DESC&page=${page}`;

    const response = await getRequest(source);
    console.log(response.data);
    dispatch({ type: "BATCH_SHOPIFY_ORDER_SUCCESS", payload: response.data });

  } catch (error) {
    dispatch({ type: "BATCH_SHOPIFY_ORDER_FAILURE", payload: error.message });
  }
};

export const getBatchShopifyRickyOrderLast = () => async (dispatch) => {
  try {
    const source = `/shopifySarkanyBatch/orders?last=true`;
    const response = await getRequest(source);
    dispatch({ type: "BATCH_SHOPIFY_ORDER_LAST_SUCCESS", payload: response.data });
  } catch (error) {
    dispatch({ type: "BATCH_SHOPIFY_ORDER_LAST_FAILURE", payload: error.message });
  }
};

//PRODUCTS SHOPIFY RICKY
export const fetchApiDataShopify = () => async (dispatch) => {
  try {
    const source = `/shopifySarkany`;
    dispatch({ type: "FETCH_API_SHOPIFY_LOADING", payload: [] });
    const response = await getRequest(source);
    dispatch({ type: "FETCH_API_SHOPIFY_SUCCESS", payload: response.data });
    dispatch(getBatchShopifySarkanyusLast());
  } catch (error) {
    dispatch({ type: "FETCH_API_SHOPIFY_FAILURE", payload: error.message });
  }
};

export const getBatchShopifySarkanyus = (page) => async (dispatch) => {
  try {
    dispatch({ type: "LOADING_START" });
    const source = `/shopifySarkanyBatch?sortOrder=DESC&page=${page}`;

    const response = await getRequest(source);
    console.log(response.data);
    dispatch({ type: "BATCH_SHOPIFY_SUCCESS", payload: response.data });

  } catch (error) {
    dispatch({ type: "BATCH_SHOPIFY_FAILURE", payload: error.message });
  }
};

export const getBatchShopifySarkanyusLast = () => async (dispatch) => {
  try {
    const source = `/shopifySarkanyBatch?last=true`;
    const response = await getRequest(source);
    console.log(response.data);
    dispatch({ type: "BATCH_SHOPIFY_LAST_SUCCESS", payload: response.data });
  } catch (error) {
    dispatch({ type: "BATCH_SHOPIFY_LAST_FAILURE", payload: error.message });
  }
};

//PRODUCTS SHOPIFY SOFIA
export const fetchApiDataSofiaSShopify = () => async (dispatch) => {
  try {
    const source = `/shopifySofia`;
    dispatch({ type: "FETCH_API_SHOPIFY_SOFIA_LOADING", payload: [] });
    const response = await getRequest(source);
    dispatch({ type: "FETCH_API_SHOPIFY_SOFIA_SUCCESS", payload: response.data });
    dispatch(getBatchShopifySofiaLast());
  } catch (error) {
    dispatch({ type: "FETCH_API_SHOPIFY_SOFIA_FAILURE", payload: error.message });
  }
};

export const getBatchShopifySofia = (page) => async (dispatch) => {
  try {
    dispatch({ type: "LOADING_START" });
    const source = `/shopifySofiaBatch/products?sortOrder=DESC&page=${page}`;

    const response = await getRequest(source);
    console.log(response.data);
    dispatch({ type: "BATCH_SHOPIFY_SOFIA_SUCCESS", payload: response.data });

  } catch (error) {
    dispatch({ type: "BATCH_SHOPIFY_SOFIA_FAILURE", payload: error.message });
  }
};

export const getBatchShopifySofiaLast = () => async (dispatch) => {
  try {
    const source = `/shopifySofiaBatch/products?last=true`;
    const response = await getRequest(source);
    console.log(response.data);
    dispatch({ type: "BATCH_SHOPIFY_SOFIA_LAST_SUCCESS", payload: response.data });
  } catch (error) {
    dispatch({ type: "F", payload: error.message });
  }
};

//ORDERS SHOPIFY SOFIA 
export const fetchApiDataShopifySofiaOrder = () => async (dispatch) => {
  try {
    const source = `/sofia-orders`;
    dispatch({ type: "FETCH_API_SHOPIFY_SOFIA_ORDER_LOADING", payload: [] });
    const response = await getRequest(source);
    dispatch({ type: "FETCH_API_SHOPIFY_SOFIA_ORDER_SUCCESS", payload: response.data });
    dispatch(getBatchShopifySarkanyusLast());
  } catch (error) {
    dispatch({ type: "FETCH_API_SHOPIFY_SOFIA_ORDER_FAILURE", payload: error.message });
  }
};

export const getBatchShopifySofiaOrder = (page) => async (dispatch) => {
  try {
    dispatch({ type: "LOADING_START" });
    const source = `/shopifySofiaBatch/orders?sortOrder=DESC&page=${page}`;

    const response = await getRequest(source);
    console.log(response.data);
    dispatch({ type: "BATCH_SHOPIFY_SOFIA_ORDER_SUCCESS", payload: response.data });

  } catch (error) {
    dispatch({ type: "BATCH_SHOPIFY_SOFIA_ORDER_FAILURE", payload: error.message });
  }
};

export const getBatchShopifySofiaOrderLast = () => async (dispatch) => {
  try {
    const source = `/shopifySofiaBatch/orders?last=true`;
    const response = await getRequest(source);
    dispatch({ type: "BATCH_SHOPIFY_SOFIA_ORDER_LAST_SUCCESS", payload: response.data });
  } catch (error) {
    dispatch({ type: "BATCH_SHOPIFY_SOFIA_ORDER_LAST_FAILURE", payload: error.message });
  }
};